import React, { useEffect, useMemo, useState } from "react";
import TableRow from "./TableRow";
import TableHeadItem from "./TableHead";
import "./table.css";
import Pagination from "../../library/components/Pagination/pagination";
import Button from "../../library/components/Button/index";
const Table = ({
  theadData,
  tbodyData,
  hasButton,
  buttonLabel,
  anchorTag,
  anchorTagName,
  anchorTagclassName,
  emptyMessage,
  category = null,
  id = null,
  className,
  radio = null,
  hasSubmitButton,
  submitButtonLabel,
  callParentSubmit,
  pagination,
  pageSize,
  paginationClass,
}) => {
  const [radioIndex, setRadioIndex] = useState(-1);
  let PageSize = pageSize;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const currentTableData = useMemo(() => {
    
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    
    return tbodyData.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, tbodyData]);
  useEffect(() => {
    let data1 = [];
    console.log(currentTableData);
    if (pagination) data1 = currentTableData;
    else data1 = tbodyData;
    setData(data1);
  }, [currentPage, tbodyData]);

  return (
   <>
    <table className={`table mt-3 ${className}`} id={id ? id : "genericTable"}>
      <thead>
        <tr className="thead">
          {theadData.map((headername, index) => {
            return <TableHeadItem key={index} item={headername} />;
          })}
        </tr>
      </thead>
      <tbody>
        {data.length == 0 ? (
          <tr>
            {" "}
            <td className="notavailable" colspan="12">
              {emptyMessage}
            </td>{" "}
          </tr>
        ) : (
          data.map((item, index) => (
            <TableRow
              key={index}
              anchorTagclassName={anchorTagclassName}
              anchorTag={anchorTag}
              anchorTagName={anchorTagName}
              data={Object.values(item)}
              Button={hasButton}
              buton_Label={buttonLabel}
              radio={radio}
              setRadioValue={setRadioIndex}
              value={index}
            />
          ))
        )}
       
      </tbody>
    </table>
    {pagination && (
          <Pagination
            className={paginationClass}
            currentPage={currentPage}
            totalCount={tbodyData.length}
            pageSize={PageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
        {hasSubmitButton && (
          <Button
            btnClass="btn btn-primary"
            value={submitButtonLabel}
            onClick={() => callParentSubmit(radioIndex)}
          />
        )}
   </>
  );
};

export default Table;
